import { useSpeciesList } from '@features/learn/useSpecies'
import { useMunicipalities } from '@features/places/usePlaces'

// Nombres de especies y municipios para las filas del panel, que solo traen identificadores.
// Usa los listados públicos (misma caché que el resto de la app). Mientras cargan, o si un
// identificador no aparece, se muestra el propio identificador.
export const lookup = (items: readonly { id: string; name: string }[] | undefined) => {
	const names = new Map(items?.map((item) => [item.id, item.name]))
	return (id: string): string => names.get(id) ?? id
}

export const useNames = () => {
	const species = useSpeciesList()
	const municipalities = useMunicipalities()
	return {
		species: lookup(species.data?.items.map((s) => ({ id: s.id, name: s.commonName }))),
		municipality: lookup(municipalities.data?.items),
	}
}
